export { default } from './slider';
